import React from "react";
import {
  Drawer,
  Button,
  Input,
  Form,
  Table,
  Row,
  Col,
  notification,
  Popconfirm,
  Select,
  DatePicker,
  Tabs,
  Card,
  Divider,
  Tag,
} from "antd";
import { withRouter } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { axiosInstance } from "../../../commons/commons";
import {
  country,
  city,
  companyAll,
  title,
  grade,
  currency,
  companyCategory,
  contactSource,
  vatCountry,
  vatEmirates,
  licenceType,
  contacts,
  vwRentalTcList,
} from "../../../constants/url";
import moment from "moment";

class Company extends React.Component {
  _isMounted = false;
  state = {
    drawerIsVisible: false,
    editFormFields: [],
    countryData: {
      list: [],
      selectedIndex: null,
    },
    cityData: {
      list: [],
      selectedIndex: null,
    },
    titleData: {
      list: [],
      selectedIndex: null,
    },
    gradeData: {
      list: [],
      selectedIndex: null,
    },
    statusData: {
      list: [],
      selectedIndex: null,
    },
    licenceData: {
      list: [],
      selectedIndex: null,
    },
    currencyData: {
      list: [],
      selectedIndex: null,
    },
    categoryData: {
      list: [],
      selectedIndex: null,
    },
    subCategoryData: {
      list: [],
      selectedIndex: null,
    },
    mainContactData: {
      list: [],
      selectedIndex: null,
    },
    sourceData: {
      list: [],
      selectedIndex: null,
    },
    vatCountryData: {
      list: [],
      selectedIndex: null,
    },
    vatEmiratesData: {
      list: [],
      selectedIndex: null,
    },
    tableData: {
      list: [],
      loading: true,
      currentPage: 1,
      pageSize: 20,
      total: 20,
    },
    contactInfo: { contracts: [] },
  };

  columns = [
    {
      title: "S.N",
      dataIndex: "SN",
      key: "SN",
      align: "center",
      fixed: "left",
      width: 80,
    },

    {
      title: "SysCode",
      dataIndex: "SysCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "UserCode",
      dataIndex: "UserCode",
      key: "SysCode",
      align: "center",
      width: 150,
    },
    {
      title: "Company Name",
      dataIndex: "CompanyName",
      key: "CompanyName",
      align: "center",
      width: 150,
      sorter: (a, b) => a.CompanyName.localeCompare(b.CompanyName),
    },
    {
      title: "Category",
      dataIndex: ["CompanyCategory", "UserName"],
      key: "ContactName",
      align: "center",
      width: 120,
      sorter: (a, b) =>
        (a.CompanyCategory || {}).UserName.localeCompare(
          (b.CompanyCategory || {}).UserName
        ),
    },
    {
      title: "Sub Category",
      dataIndex: ["CompanySubCategory", "UserName"],
      key: "ContactName",
      align: "center",
      width: 120,
      sorter: (a, b) =>
        (a.CompanySubCategory || {}).UserName.localeCompare(
          (b.CompanySubCategory || {}).UserName
        ),
    },
    {
      title: "Created At",
      dataIndex: "DateCreated",
      key: "DateCreated",
      align: "center",
      width: 150,
      render: (value) => (value ? value.split("T")[0] : "N/A"),
      sorter: (a, b) => new Date(a.DateCreated) - new Date(b.DateCreated),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      width: 110,
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <EditOutlined
              style={{ color: "#1890ff" }}
              onClick={async () => {
                const tmpList = [];
                let state = this.state;
                // populate information for this company
                Object.keys(item).map((key) => {
                  tmpList.push({ name: key, value: item[key] });
                  return key;
                });
                tmpList.push({
                  name: "TradeLicenceExpiryDate",
                  value: item.TradeLicenceExpiryDate
                    ? moment(item.TradeLicenceExpiryDate)
                    : null,
                });
                // populate and override especially the dropdown informations
                for (let title of state.titleData.list)
                  if (
                    item.Title.toLowerCase() === title.UserName.toLowerCase()
                  ) {
                    state.titleData.selectedIndex =
                      state.titleData.list.indexOf(title);
                    tmpList.push({
                      name: "Title",
                      value:
                        "title+-" +
                        state.titleData.list.indexOf(title) +
                        "+-" +
                        title.UserName,
                    });
                    break;
                  }
                if (state.titleData.selectedIndex === null)
                  tmpList.push({ name: "Title", value: null });
                for (let country of state.countryData.list)
                  if (item.CountryID === country.CountryID) {
                    state.countryData.selectedIndex =
                      state.countryData.list.indexOf(country);
                    tmpList.push({
                      name: "CountryID",
                      value:
                        "country+-" +
                        state.countryData.list.indexOf(country) +
                        "+-" +
                        country.UserName,
                    });
                    if (state.countryData.selectedIndex !== null)
                      await axiosInstance
                        .get(
                          city +
                            "?CountryID=" +
                            state.countryData.list[
                              state.countryData.selectedIndex
                            ].CountryID
                        )
                        .then((res) => {
                          if (res.data.success)
                            state.cityData = {
                              list: res.data.message,
                              selectedIndex: null,
                            };
                        })
                        .catch(() => {});
                    break;
                  }
                // reset country form if none selected or doesnot match
                if (state.countryData.selectedIndex === null)
                  tmpList.push({ name: "CountryID", value: null });
                for (let city of state.cityData.list)
                  if (item.CityID === city.CityID) {
                    state.cityData.selectedIndex =
                      state.cityData.list.indexOf(city);
                    tmpList.push({
                      name: "CityID",
                      value:
                        "city+-" +
                        state.cityData.list.indexOf(city) +
                        "+-" +
                        city.UserName,
                    });
                    break;
                  }
                if (state.cityData.selectedIndex === null)
                  tmpList.push({ name: "CityID", value: null });
                for (let grade of state.gradeData.list)
                  if (item.GradeID === grade.GradeID) {
                    state.gradeData.selectedIndex =
                      state.gradeData.list.indexOf(grade);
                    tmpList.push({
                      name: "GradeID",
                      value:
                        "grade+-" +
                        state.gradeData.list.indexOf(grade) +
                        "+-" +
                        grade.UserName,
                    });
                    break;
                  }
                if (state.gradeData.selectedIndex === null)
                  tmpList.push({ name: "GradeID", value: null });
                for (let licence of state.licenceData.list)
                  if (item.LicenceTypeID === licence.CompanyLicenceTypeID) {
                    state.licenceData.selectedIndex =
                      state.licenceData.list.indexOf(licence);
                    tmpList.push({
                      name: "LicenceTypeID",
                      value:
                        "licence+-" +
                        state.licenceData.list.indexOf(licence) +
                        "+-" +
                        licence.UserName,
                    });
                    break;
                  }
                if (state.licenceData.selectedIndex === null)
                  tmpList.push({ name: "LicenceTypeID", value: null });
                for (let status of state.statusData.list)
                  if (
                    Number(item.ActiveStatus) === status.CompanyActiveStatusId
                  ) {
                    state.statusData.selectedIndex =
                      state.statusData.list.indexOf(status);
                    tmpList.push({
                      name: "ActiveStatus",
                      value:
                        "status+-" +
                        state.statusData.list.indexOf(status) +
                        "+-" +
                        status.UserName,
                    });
                    break;
                  }
                if (state.statusData.selectedIndex === null)
                  tmpList.push({ name: "ActiveStatus", value: null });
                for (let currency of state.currencyData.list)
                  if (item.CurrencyId === currency.CompanyActiveStatusId) {
                    state.currencyData.selectedIndex =
                      state.currencyData.list.indexOf(currency);
                    tmpList.push({
                      name: "CurrencyId",
                      value:
                        "currency+-" +
                        state.currencyData.list.indexOf(currency) +
                        "+-" +
                        currency.UserName,
                    });
                    break;
                  }
                if (state.currencyData.selectedIndex === null)
                  tmpList.push({ name: "CurrencyId", value: null });
                for (let category of state.categoryData.list)
                  if (item.CompanyCategoryID === category.CompanyCategoryID) {
                    state.categoryData.selectedIndex =
                      state.categoryData.list.indexOf(category);
                    tmpList.push({
                      name: "CompanyCategoryID",
                      value:
                        "category+-" +
                        state.categoryData.list.indexOf(category) +
                        "+-" +
                        category.UserName,
                    });
                    if (state.categoryData.selectedIndex !== null)
                      state.subCategoryData.list =
                        state.categoryData.list[
                          state.categoryData.list.indexOf(category)
                        ].CompanySubCategories || [];
                    break;
                  }
                if (state.categoryData.selectedIndex === null)
                  tmpList.push({ name: "CompanyCategoryID", value: null });
                for (let subCategory of state.subCategoryData.list)
                  if (
                    item.CompanySubCategoryID ===
                    subCategory.CompanySubCategoryID
                  ) {
                    state.subCategoryData.selectedIndex =
                      state.subCategoryData.list.indexOf(subCategory);
                    tmpList.push({
                      name: "CompanySubCategoryID",
                      value:
                        "subCategory+-" +
                        state.subCategoryData.list.indexOf(subCategory) +
                        "+-" +
                        subCategory.UserName,
                    });
                    break;
                  }
                if (state.subCategoryData.selectedIndex === null)
                  tmpList.push({ name: "CompanySubCategoryID", value: null });
                for (let mainContact of state.mainContactData.list)
                  if (item.MainContactPerson === mainContact.ContactID) {
                    state.mainContactData.selectedIndex =
                      state.mainContactData.list.indexOf(mainContact);
                    tmpList.push({
                      name: "MainContactPerson",
                      value:
                        "mainContact+-" +
                        state.mainContactData.list.indexOf(mainContact) +
                        "+-" +
                        mainContact.ContactName,
                    });
                    break;
                  }
                if (state.mainContactData.selectedIndex === null)
                  tmpList.push({ name: "MainContactPerson", value: null });
                for (let source of state.sourceData.list)
                  if (item.ContactSourceID === source.ContactSourceID) {
                    state.sourceData.selectedIndex =
                      state.sourceData.list.indexOf(source);
                    tmpList.push({
                      name: "ContactSourceID",
                      value:
                        "source+-" +
                        state.sourceData.list.indexOf(source) +
                        "+-" +
                        source.ContactName,
                    });
                    break;
                  }
                if (state.sourceData.selectedIndex === null)
                  tmpList.push({ name: "ContactSourceID", value: null });
                for (let vatCountry of state.vatCountryData.list)
                  if (item.VAT_Country_Id === vatCountry.VAT_CountryId) {
                    state.vatCountryData.selectedIndex =
                      state.vatCountryData.list.indexOf(vatCountry);
                    tmpList.push({
                      name: "VAT_Country_Id",
                      value:
                        "vatCountry+-" +
                        state.vatCountryData.list.indexOf(vatCountry) +
                        "+-" +
                        vatCountry.VAT_Country,
                    });
                    break;
                  }
                if (state.vatCountryData.selectedIndex === null)
                  tmpList.push({ name: "VAT_Country_Id", value: null });
                for (let vatEmirates of state.vatEmiratesData.list)
                  if (item.VAT_Emirate_Id === vatEmirates.VAT_EmirateId) {
                    state.vatEmiratesData.selectedIndex =
                      state.vatEmiratesData.list.indexOf(vatEmirates);
                    tmpList.push({
                      name: "VAT_Emirate_Id",
                      value:
                        "vatEmirates+-" +
                        state.vatEmiratesData.list.indexOf(vatEmirates) +
                        "+-" +
                        vatEmirates.VAT_Emirate,
                    });
                    break;
                  }
                if (state.vatEmiratesData.selectedIndex === null)
                  tmpList.push({ name: "VAT_Emirate_Id", value: null });
                state.editFormFields = tmpList;
                state.drawerIsVisible = true;
                this.setState(state);
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={() => {
                axiosInstance
                  .delete(companyAll + "/" + item.CompanyID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        duration: 3,
                        message: "Success",
                        description: res.data.message || "Done!",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.getInitialState().then((st) => {
                      this.resetFields();
                      this.setState(st);
                    });
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined style={{ color: "red" }} />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  formRef = null;

  resetFields = () => {
    if (this.formRef) {
      this.formRef.resetFields();
    }
  };

  getInitialState = async (drawerIsVisible) => {
    let state = {
      drawerIsVisible: drawerIsVisible || false,
      editFormFields: [],
      countryData: {
        list: [],
        selectedIndex: null,
      },
      cityData: {
        list: [],
        selectedIndex: null,
      },
      communityData: {
        list: [],
        selectedIndex: null,
      },
      titleData: {
        list: [],
        selectedIndex: null,
      },
      gradeData: {
        list: [],
        selectedIndex: null,
      },
      licenceData: {
        list: [],
        selectedIndex: null,
      },
      statusData: {
        list: [],
        selectedIndex: null,
      },
      currencyData: {
        list: [],
        selectedIndex: null,
      },
      categoryData: {
        list: [],
        selectedIndex: null,
      },
      subCategoryData: {
        list: [],
        selectedIndex: null,
      },
      mainContactData: {
        list: [],
        selectedIndex: null,
      },
      sourceData: {
        list: [],
        selectedIndex: null,
      },
      vatCountryData: {
        list: [],
        selectedIndex: null,
      },
      vatEmiratesData: {
        list: [],
        selectedIndex: null,
      },
      tableData: {
        list: this.state.tableData.list,
        loading: false,
        currentPage: 1,
        pageSize: 20,
        total: 20,
      },
      contactInfo: { contracts: [] },
    };
    await axiosInstance
      .get(
        companyAll +
          "?offset=" +
          (state.tableData.currentPage - 1) * state.tableData.pageSize +
          "&limit=" +
          state.tableData.pageSize
      )
      .then((res) => {
        if (res.data.success) {
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows.map((data, index) => {
            data.SN =
              (state.tableData.currentPage - 1) * state.tableData.pageSize +
              1 +
              index;
            data.key = index;
            return data;
          });
        }
      })
      .catch(() => {});
    await axiosInstance
      .get(country)
      .then((res) => {
        if (res.data.success) state.countryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(title)
      .then((res) => {
        if (res.data.success) state.titleData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(grade)
      .then((res) => {
        if (res.data.success) state.gradeData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(licenceType)
      .then((res) => {
        if (res.data.success) state.licenceData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contacts)
      .then((res) => {
        if (res.data.success)
          state.mainContactData.list = res.data.message.rows;
      })
      .catch(() => {});
    await axiosInstance
      .get(companyAll + "/activeStatus")
      .then((res) => {
        if (res.data.success) state.statusData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(currency)
      .then((res) => {
        if (res.data.success) state.currencyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(companyCategory)
      .then((res) => {
        if (res.data.success) state.categoryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(contactSource)
      .then((res) => {
        if (res.data.success) state.sourceData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(vatCountry)
      .then((res) => {
        if (res.data.success) state.vatCountryData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(vatEmirates)
      .then((res) => {
        if (res.data.success) state.vatEmiratesData.list = res.data.message;
      })
      .catch(() => {});
    return state;
  };

  onCreateNew = (drawerIsVisible = false) => {
    return this.formRef
      .validateFields()
      .then(async (values) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: true },
        });
        values.Title = values.Title.split("+-")[2];
        values.CountryID = Number(
          this.state.countryData.list[values.CountryID.split("+-")[1]].CountryID
        );
        values.CityID = Number(
          this.state.cityData.list[values.CityID.split("+-")[1]].CityID
        );
        if (values.GradeID)
          values.GradeID = Number(
            this.state.gradeData.list[values.GradeID.split("+-")[1]].GradeID
          );
        if (values.LicenceTypeID)
          values.LicenceTypeID = Number(
            this.state.licenceData.list[values.LicenceTypeID.split("+-")[1]]
              .CompanyLicenceTypeID
          );
        if (values.ActiveStatus)
          values.ActiveStatus = Number(
            this.state.statusData.list[values.ActiveStatus.split("+-")[1]]
              .CompanyActiveStatusId
          );
        if (values.CurrencyId)
          values.CurrencyId = Number(
            this.state.currencyData.list[values.CurrencyId.split("+-")[1]]
              .CurrencyID
          );
        if (values.CompanyCategoryID)
          values.CompanyCategoryID = Number(
            this.state.categoryData.list[
              values.CompanyCategoryID.split("+-")[1]
            ].CompanyCategoryID
          );
        if (values.CompanySubCategoryID)
          values.CompanySubCategoryID = Number(
            this.state.subCategoryData.list[
              values.CompanySubCategoryID.split("+-")[1]
            ].CompanySubCategoryID
          );
        if (values.MainContactPerson)
          values.MainContactPerson = Number(
            this.state.mainContactData.list[
              values.MainContactPerson.split("+-")[1]
            ].ContactID
          );
        if (values.ContactSourceID)
          values.ContactSourceID = Number(
            this.state.sourceData.list[values.ContactSourceID.split("+-")[1]]
              .ContactSourceID
          );
        if (values.VAT_Country_Id)
          values.VAT_Country_Id = Number(
            this.state.vatCountryData.list[values.VAT_Country_Id.split("+-")[1]]
              .VAT_CountryId
          );
        if (values.VAT_Emirate_Id)
          values.VAT_Emirate_Id = Number(
            this.state.vatEmiratesData.list[
              values.VAT_Emirate_Id.split("+-")[1]
            ].VAT_EmirateId
          );
        await (this.state.editFormFields.length
          ? axiosInstance.put(companyAll, values)
          : axiosInstance.post(companyAll, values)
        )
          .then((res) => {
            if (res && res.data.success) {
              notification.success({
                duration: 3,
                message: "Success",
                description: res.data.message || "Done!",
              });
              this.getInitialState(drawerIsVisible).then((st) => {
                this.resetFields();
                this.setState(st);
              });
            } else
              notification.error({
                message: "Fail",
                description: res.data.message || "Something went wrong!",
              });
          })
          .catch(() => {
            this.setState({
              tableData: { list: this.state.tableData.list, loading: false },
            });
          });
      })
      .catch((err) => {
        this.setState({
          tableData: { list: this.state.tableData.list, loading: false },
        });
      });
  };

  onChange = (value) => {
    if (!value) return;
    let type, theIndex;
    type = value.split("+-")[0];
    theIndex = value.split("+-")[1];
    switch (type) {
      case "country":
        this.setState(
          {
            countryData: {
              list: this.state.countryData.list,
              selectedIndex: theIndex,
            },
            cityData: {
              list: [],
              selectedIndex: null,
            },
          },
          () =>
            axiosInstance
              .get(
                city +
                  "?CountryID=" +
                  this.state.countryData.list[
                    this.state.countryData.selectedIndex
                  ].CountryID
              )
              .then((res) => {
                if (res.data.success)
                  this.setState({
                    cityData: {
                      list: res.data.message,
                      selectedIndex: null,
                    },
                  });
              })
              .catch(() => {})
        );
        break;
      case "category":
        this.setState({
          categoryData: {
            list: this.state.categoryData.list,
            selectedIndex: theIndex,
          },
          subCategoryData: {
            list:
              this.state.categoryData.list[theIndex].CompanySubCategories || [],
            selectedIndex: null,
          },
        });
        break;
      default:
        break;
    }
  };

  onSearch = () => {
    let state = this.state;
    state.tableData.loading = true;
    this.setState(state);
    state.tableData.loading = false;
    axiosInstance
      .get(
        companyAll +
          "?offset=" +
          (state.tableData.currentPage - 1) * state.tableData.pageSize +
          "&limit=" +
          state.tableData.pageSize
      )
      .then((res) => {
        if (res.data.success) {
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows.map((data, index) => {
            data.SN =
              (state.tableData.currentPage - 1) * state.tableData.pageSize +
              1 +
              index;
            data.key = index;
            return data;
          });
        }
        this.setState(state);
      })
      .catch(() => {
        this.setState(state);
      });
  };

  displayContactInfo = (contactInfo) => {
    let state = this.state;
    state.contactInfo = { ...contactInfo, contracts: [] };
    this.setState(state);
    axiosInstance
      .post(vwRentalTcList, {
        attributes: [
          "CompanyID",
          "LegalCompany_ID",
          "LegalcompanyName",
          "Division",
          "Division_ID",
          "ProjectID",
          "ProjectName",
          "BuildingID",
          "BuildingName",
          "UnitID",
          "UnitNo",
        ],
        where: {
          TenantID: contactInfo.CompanyID,
          TenantType: "C",
          // TCStatus: "Active",
        },
      })
      .then((res) => {
        /**
         * currentTCNoIndex for identifying index of the
         * contract that a tenant is logged in with.
         */
        if (res.data.success) {
          state.contactInfo.contracts = res.data.message.map(
            (contract, index) => {
              contract.key = index;
              contract.SN = index + 1;
              contract.TCDate = contract.TCDate.split("T")[0];
              contract.TCFromDate = contract.TCFromDate.split("T")[0];
              contract.TCToDate = contract.TCToDate.split("T")[0];
              return contract;
            }
          );
        } else
          notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong!",
          });
        this.setState(state);
      })
      .catch((err) => {
        this.setState(state);
      });
  };

  onReset = () => {
    this.getInitialState().then((st) => this.setState(st));
  };

  componentDidMount() {
    this._isMounted = true;
    this.getInitialState().then((st) =>
      this._isMounted ? this.setState(st) : null
    );
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <div>
        <Drawer
          title="New Company"
          placement="right"
          closable={false}
          onClose={() => {
            this.resetFields();
            this.setState({ editFormFields: [], drawerIsVisible: false });
          }}
          visible={this.state.drawerIsVisible}
          width={window.innerWidth - 40 > 400 ? 380 : window.innerWidth - 40}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                name="create"
                onClick={() => this.onCreateNew()}
                type="primary"
                style={{ borderRadius: 20 }}
              >
                {this.state.editFormFields.length ? "Save" : "Create"}
              </Button>
              {!this.state.editFormFields.length ? (
                <Button
                  style={{ borderRadius: 20 }}
                  onClick={() => this.onCreateNew(true)}
                  type="primary"
                >
                  Create and add another
                </Button>
              ) : null}
              <Button
                style={{ borderRadius: 20 }}
                onClick={() => {
                  this.resetFields();
                  this.setState({
                    editFormFields: [],
                    drawerIsVisible: this.state.editFormFields.length > 0,
                  });
                }}
              >
                Cancel
              </Button>
            </div>
          }
        >
          <Form
            layout="horizontal"
            colon={false}
            ref={(ref) => (ref ? (this.formRef = ref) : null)}
            fields={this.state.editFormFields}
            requiredMark
          >
            <Form.Item
              key="CompanyID"
              name="CompanyID"
              label="CompanyID"
              labelAlign="left"
              labelCol={{ span: 24 }}
              hidden
              rules={[{ required: false, message: "Please enter company id" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="UserCode"
              name="UserCode"
              label="User Code"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter user code" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Title"
              name="Title"
              label="Title"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select title" }]}
            >
              <Select
                showSearch
                placeholder="Select title"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.titleData.list.map((title, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"title+-" + index + "+-" + title.UserName}
                    >
                      {title.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CompanyName"
              name="CompanyName"
              label="CompanyName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter company name" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="CountryID"
              name="CountryID"
              label="Country"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select country" }]}
            >
              <Select
                showSearch
                placeholder="Select a country"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.countryData.list.map((country, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"country+-" + index + "+-" + country.UserName}
                    >
                      {country.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CityID"
              name="CityID"
              label="City"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select city" }]}
            >
              <Select
                showSearch
                placeholder="Select a city"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.cityData.list.map((city, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"city+-" + index + "+-" + city.UserName}
                    >
                      {city.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="Phone"
              name="Phone"
              label="Phone"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please enter phone number" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="EmailID"
              name="EmailID"
              label="Email"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message: "Please enter email address" },
              ]}
            >
              <Input type="email"></Input>
            </Form.Item>
            <Form.Item
              key="Website"
              name="Website"
              label="Website"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter Website" }]}
            >
              <Input type="url"></Input>
            </Form.Item>
            <Form.Item
              key="Fax"
              name="Fax"
              label="Fax"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter Fax" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="PObox"
              name="PObox"
              label="P.O. Box"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please enter P.O Box" }]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="GradeID"
              name="GradeID"
              label="Grade"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: false, message: "Please select grade" }]}
            >
              <Select
                showSearch
                placeholder="Select grade"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.gradeData.list.map((grade, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"grade+-" + index + "+-" + grade.UserName}
                    >
                      {grade.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="LicenceTypeID"
              name="LicenceTypeID"
              label="Licence Type"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select licence type" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select licence"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.licenceData.list.map((licence, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"licence+-" + index + "+-" + licence.UserName}
                    >
                      {licence.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="TradeLicenceNo"
              name="TradeLicenceNo"
              label="Trade Licence no."
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please enter trade licence no." },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="TradeLicenceExpiryDate"
              name="TradeLicenceExpiryDate"
              label="Trade Licence Expiry Date"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter trade licence expiry date",
                },
              ]}
            >
              <DatePicker
                // format={this.state.dateFormat}
                // allowClear={false}
                style={{
                  width: "100%",
                }}
                // onChange={(val) => {
                //   let state = this.state;
                //   state.complaintData.ComplaintDate = val;
                //   this.setState(state);
                // }}
                // value={this.state.complaintData.ComplaintDate}
              ></DatePicker>
            </Form.Item>
            <Form.Item
              key="TradeLicenceIssuingAuthority"
              name="TradeLicenceIssuingAuthority"
              label="Licence Issuing Authority"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter licence issuing authority",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="SponsorName"
              name="SponsorName"
              label="SponsorName"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter sponsor name",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="CompanyAddress"
              name="CompanyAddress"
              label="Address"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter company address",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="Remarks"
              name="Remarks"
              label="Remarks"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please enter remarks",
                },
              ]}
            >
              <Input></Input>
            </Form.Item>
            <Form.Item
              key="ActiveStatus"
              name="ActiveStatus"
              label="Active Status"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                { required: false, message: "Please select active status" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select status"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.statusData.list.map((status, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"status+-" + index + "+-" + status.UserName}
                    >
                      {status.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CurrencyId"
              name="CurrencyId"
              label="Currency"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select currency" }]}
            >
              <Select
                showSearch
                placeholder="Select currency"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.currencyData.list.map((currency, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"currency+-" + index + "+-" + currency.UserName}
                    >
                      {currency.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CompanyCategoryID"
              name="CompanyCategoryID"
              label="Category"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select category" }]}
            >
              <Select
                showSearch
                placeholder="Select category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.categoryData.list.map((category, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"category+-" + index + "+-" + category.UserName}
                    >
                      {category.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="CompanySubCategoryID"
              name="CompanySubCategoryID"
              label="SubCategory"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[{ required: true, message: "Please select subcategory" }]}
            >
              <Select
                showSearch
                placeholder="Select sub category"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.subCategoryData.list.map((category, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"subCategory+-" + index + "+-" + category.UserName}
                    >
                      {category.UserName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="MainContactPerson"
              name="MainContactPerson"
              label="MainContactPerson"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select main contact person",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select contact person"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.mainContactData.list.map((mainContact, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={
                        "mainContact+-" + index + "+-" + mainContact.ContactName
                      }
                    >
                      {mainContact.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              key="ContactSourceID"
              name="ContactSourceID"
              label="Source"
              labelAlign="left"
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: false,
                  message: "Please select source",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select source"
                optionFilterProp="children"
                onChange={this.onChange}
                onSearch={this.onSearch}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.sourceData.list.map((source, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"source+-" + index + "+-" + source.ContactName}
                    >
                      {source.ContactName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Tabs defaultActiveKey="1">
              <Tabs.TabPane tab="VAT" key="1">
                <Form.Item
                  key="VAT_Regd_No"
                  name="VAT_Regd_No"
                  label="VAT Registration No."
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: false,
                      message: "Please enter VAT registration number",
                    },
                  ]}
                >
                  <Input></Input>
                </Form.Item>
                <Form.Item
                  key="VAT_Country_Id"
                  name="VAT_Country_Id"
                  label="VAT Local"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select VAT local",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select local"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.vatCountryData.list.map((vatCountry, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={
                            "vatCountry+-" +
                            index +
                            "+-" +
                            vatCountry.VAT_Country
                          }
                        >
                          {vatCountry.VAT_Country}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  key="VAT_Emirate_Id"
                  name="VAT_Emirate_Id"
                  label="VAT Emirates"
                  labelAlign="left"
                  labelCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select VAT emirates",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select emirates"
                    optionFilterProp="children"
                    onChange={this.onChange}
                    onSearch={this.onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {this.state.vatEmiratesData.list.map(
                      (vatEmirates, index) => {
                        return (
                          <Select.Option
                            key={index}
                            value={
                              "vatEmirates+-" +
                              index +
                              "+-" +
                              vatEmirates.VAT_Emirate
                            }
                          >
                            {vatEmirates.VAT_Emirate}
                          </Select.Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
              </Tabs.TabPane>
              <Tabs.TabPane tab="Doc Expiry" key="2" disabled></Tabs.TabPane>
            </Tabs>
          </Form>
        </Drawer>
        <Row style={{ margin: "10px 10px 10px 10px" }}>
          <Col span={4}></Col>
          <Col span={16} style={{ textAlign: "center" }}>
            <h3>Company</h3>
          </Col>
          <Col span={4} style={{ textAlign: "right" }}>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ drawerIsVisible: true });
              }}
              style={{ borderRadius: 20 }}
            >
              New
            </Button>
          </Col>
        </Row>
        <Row gutter={[12, 12]}>
          {this.state.contactInfo.CompanyID ? (
            <Col
              {...(this.state.contactInfo.CompanyID
                ? { xs: 24, sm: 24, md: 24, lg: 10 }
                : { xs: 24, sm: 24, md: 24, lg: 0 })}
              // style={{ padding: 15 }}
            >
              <Card
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
                title={
                  <h3 style={{ textAlign: "center" }}>
                    {(this.state.contactInfo.Title || "") +
                      " " +
                      this.state.contactInfo.CompanyName}
                  </h3>
                }
                bodyStyle={{
                  padding: 10,
                  overflowY: "scroll",
                  overflowX: "hidden",
                  maxHeight: window.innerHeight - 210,
                }}
              >
                {this.state.contactInfo.CompanyID ? (
                  <Row>
                    {this.state.contactInfo.CountryID ? (
                      <Col span={24}>
                        <h4>
                          Country:{" "}
                          {(
                            this.state.countryData.list.filter(
                              (country) =>
                                country.CountryID ===
                                this.state.contactInfo.CountryID
                            )[0] || {}
                          ).UserName || "N/A"}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.CompanyAddress ? (
                      <Col span={24}>
                        <h4>
                          Address:
                          {" " + this.state.contactInfo.CompanyAddress}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.PObox ? (
                      <Col span={24}>
                        <h4>
                          PO. Box:
                          {" " + this.state.contactInfo.PObox}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Phone ? (
                      <Col span={24}>
                        <h4>
                          Phone:
                          {" " + this.state.contactInfo.Phone}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Fax ? (
                      <Col span={24}>
                        <h4>
                          Fax:
                          {" " + this.state.contactInfo.Fax}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.EmailID ? (
                      <Col span={24}>
                        <h4>
                          Email:
                          {" " + this.state.contactInfo.EmailID}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.TradeLicenceNo ? (
                      <Col span={24}>
                        <h4>
                          Trade Licence No.:
                          {" " + this.state.contactInfo.TradeLicenceNo}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.TradeLicenceIssuingAuthority ? (
                      <Col span={24}>
                        <h4>
                          Trade Licence Issuing Authority:
                          {" " +
                            this.state.contactInfo.TradeLicenceIssuingAuthority}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.TradeLicenceExpiryDate ? (
                      <Col span={24}>
                        <h4>
                          Trade Licence Expiry Date:
                          {" " +
                            this.state.contactInfo.TradeLicenceExpiryDate.split(
                              "T"
                            )[0]}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Website ? (
                      <Col span={24}>
                        <h4>
                          Website:
                          {" " + this.state.contactInfo.Website}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.SponsorName ? (
                      <Col span={24}>
                        <h4>
                          Sponsor Name:
                          {" " + this.state.contactInfo.SponsorName}
                        </h4>
                      </Col>
                    ) : null}
                    {this.state.contactInfo.Remarks ? (
                      <Col span={24}>
                        <h4>
                          Remarks:
                          {" " + this.state.contactInfo.Remarks}
                        </h4>
                      </Col>
                    ) : null}
                  </Row>
                ) : null}
                {this.state.contactInfo.contracts.length ? (
                  <>
                    <Row>
                      <Col span={24}>
                        <Divider orientation="left">Contracts</Divider>
                      </Col>
                    </Row>
                    <Row gutter={[24, 24]}>
                      {this.state.contactInfo.contracts.map((contract) => {
                        return (
                          <Col
                            span={24}
                            style={{
                              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                              transition: "0.3s",
                            }}
                          >
                            <Row>
                              <Col span={24}>
                                <h3>
                                  Status:{" "}
                                  <Tag
                                    color="cyan"
                                    style={{ borderRadius: 25 }}
                                  >
                                    {contract.TCStatus}
                                  </Tag>
                                  {new Date(contract.TCToDate) < new Date() ? (
                                    <Tag
                                      color="red"
                                      style={{ borderRadius: 25 }}
                                    >
                                      Expired
                                    </Tag>
                                  ) : null}
                                </h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>
                                  Contract No.:{" "}
                                  <Tag
                                    color="green"
                                    style={{ borderRadius: 25 }}
                                  >
                                    {contract.TCNo}
                                  </Tag>
                                </h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Contract Date: {contract.TCDate}</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Valid From: {contract.TCFromDate}</h3>
                              </Col>
                            </Row>
                            <Row>
                              <Col span={24}>
                                <h3>Valid Till: {contract.TCToDate}</h3>
                              </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ padding: 10 }}>
                              {(contract.RentalTCUnits || []).map(
                                (rtc, rtcIndex) => {
                                  if (
                                    (rtc.Unit || {}).UnitNo &&
                                    (rtc.Unit.Building || {}).BuildingName
                                  )
                                    return (
                                      <Col
                                        lg={12}
                                        md={24}
                                        sm={24}
                                        xs={24}
                                        style={{
                                          boxShadow:
                                            "0 4px 8px 0 rgba(0,0,0,0.4)",
                                          transition: "0.3s",
                                          padding: 10,
                                        }}
                                      >
                                        <Row>
                                          <Col span={24}>
                                            <h3>
                                              Building:{" "}
                                              {rtc.Unit.Building.BuildingName}
                                            </h3>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col span={24}>
                                            <h3>Unit: {rtc.Unit.UnitNo}</h3>
                                          </Col>
                                        </Row>
                                      </Col>
                                    );
                                  return null;
                                }
                              )}
                            </Row>
                          </Col>
                        );
                      })}
                    </Row>
                  </>
                ) : null}
              </Card>
            </Col>
          ) : null}
          <Col
            {...(this.state.contactInfo.CompanyID
              ? { xs: 24, sm: 24, md: 24, lg: 14 }
              : { xs: 24, sm: 24, md: 24, lg: 24 })}
          >
            <Table
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    // console.log(record, "sucs");
                    this.displayContactInfo(record);
                  },
                };
              }}
              style={{
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                transition: "0.3s",
                borderRadius: 20,
                width: "100%",
              }}
              loading={this.state.tableData.loading}
              dataSource={this.state.tableData.list}
              columns={this.columns}
              scroll={{ y: window.innerHeight - 290 }}
              pagination={{
                size: "small",
                disabled: false,
                pageSize: this.state.tableData.pageSize,
                showQuickJumper: true,
                showSizeChanger: true,
                // total: this.state.tableData.list.length,
                total: this.state.tableData.total,
                onChange: (page, pageSize) => {
                  let state = this.state;
                  state.tableData.currentPage = page;
                  state.tableData.pageSize = pageSize;
                  this.setState(state, this.onSearch);
                },
              }}
            ></Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withRouter(Company);
